import React, { useState, useEffect } from 'react'
// import PropTypes from 'prop-types';
import { path } from 'ramda'
import { Link } from 'react-router-dom'
import bindAllActions from '../../common/bindAllActions'
import { isCellularDevice, hasCellularSubscription, displayPriceForSubscription, subIsIap, subStatusDisplay, awnPlusAnnualMonthlySwitchAvail, subIsPlus, displayCancelPlusOnIosMessage, getExpiredCellularSubscription, getSubscriptionDisplayName, shouldHideIosCanceledSub } from '.'
import AutoRenewToggle from './AutoRenewToggle'
import UpgradeDowngradeLink from './UpgradeDowngradeLink'

// Should display a row for each case:
// * An active subscription, regardless of stationType.  This supports deleted stations that could be re-added.
// * StationType == KestrelMet6000.  This supports adding new subscription to a lapsed station.

function DisplaySubscription ({ user, device, userActions }) {
  const userSubs = path(['info', 'payments', 'subscriptions'], user) || []
  const devices = path(['devices'], device) || []

  let atLeastOneRow = false
  if (userSubs.length > 0) atLeastOneRow = true
  const noSubscriptions = (
    <tr>
      <td colspan='7'>
        You currently have no subscriptions.
      </td>
    </tr>
  )
  // init
  useEffect(() => {
    userActions.refreshUser()
  }, [userActions])

  const hasMultiplePlusSubs = userSubs.filter(subIsPlus).length > 1

  return (
    <div className='payment-display-subscription'>
      <div className='aw-fields'>
        <table>
          <thead>
            <th>Applies to</th>
            <th>Product</th>
            <th>Billing Period</th>
            <th>Status</th>
            <th>Renews/Expires</th>
            <th>Renewal Price</th>
            <th>Auto-renew</th>
          </thead>
          <tbody>
            {devices.map((dev, i) => {
              const mac = path(['macAddress'], dev)
              const cellDeviceNeedsSubscription = (isCellularDevice(dev) && !hasCellularSubscription(user, mac))
              // const cellDeviceNeedsSubscription = (isCellularDevice(dev) && true)
              if (!cellDeviceNeedsSubscription) return null
              atLeastOneRow = true
              const currentDevice = dev // for naming consistency in CellPlanModal
              const expiredSubscription = getExpiredCellularSubscription(user, mac)

              return (
                <tr key={i}>
                  <td>{mac}</td>
                  <td>KestrelMet Standard 1 Year Subscription</td>
                  <td>Annual</td>
                  <td>{expiredSubscription ? 'Expired' : '--'}</td>
                  <td>{expiredSubscription ? `${moment(expiredSubscription.timestamp).format('MMM D, YYYY')}` : '--'}</td>
                  <td>$99.99</td>
                  <td>
                    <Link
                      to={`/subscriptions/checkout?subscription=kestrelmet-one-year-subscription-new&deviceId=${currentDevice._id}`}
                      className='btn btn-primary btn-lg'
                    >
                      Add Plan
                    </Link>
                  </td>
                </tr>
              )
            })}

            {userSubs.map((sub, i) => {
              if (hasMultiplePlusSubs && subIsPlus(sub) && subIsIap(sub)) {
                return null
              }
              if (shouldHideIosCanceledSub(sub, user)) {
                return null
              }
              if (/awn_sms/.test(sub.productName)) {
                return null
              }
              return (
                <tr key={i}>
                  <td>{sub.macAddress || 'Account'}</td>
                  <td>
                    {getSubscriptionDisplayName(sub)}
                    <br/>
                    <UpgradeDowngradeLink sub={sub} user={user} userActions={userActions} />
                    {subIsPlus(sub) && displayCancelPlusOnIosMessage(user) && (
                      <a href='https://apps.apple.com/account/subscriptions' target='_blank' rel='noreferrer' className='cancel'>Cancel your Apple subscription</a>
                    )}
                  </td>
                  <td>
                    {/monthly/.test(sub.productName) ? 'Monthly' : 'Annual'}<br/>
                    {awnPlusAnnualMonthlySwitchAvail(user, sub) && (
                      <a
                        className='change-plan'
                        onClick={() => userActions.doModal({ type: 'plus-subscription' })}
                      >
                        Change plan
                      </a>
                    )}
                    {/awn-camera/.test(sub.productName) && (
                      <a
                        className='change-plan'
                        onClick={() => userActions.doModal({ type: 'enhanced-cam', data: { currentDevice: device.devices.find(d => d.macAddress === sub.macAddress) } })}
                      >
                        Change plan
                      </a>
                    )}
                  </td>
                  <td>{subStatusDisplay(sub)}</td>
                  <td>{moment(sub.currentPeriodEnd * 1000).format('MMM, D, YYYY')}</td>
                  <td>{displayPriceForSubscription(sub)}</td>
                  <td className='switch'>
                    <AutoRenewToggle
                      sub={sub}
                      user={user}
                      userActions={userActions}
                    />
                  </td>
                </tr>
              )
            })}
            {atLeastOneRow ? '' : noSubscriptions}
          </tbody>
        </table>
      </div>
    </div>
  )
}
export default bindAllActions(DisplaySubscription)

DisplaySubscription.propTypes = {}
DisplaySubscription.defaultProps = {}

DisplaySubscription.displayName = 'DisplaySubscription'
